import { z } from "zod";
import { IsoDateTime, OpaqueId, Position, Seq } from "./common.js";
/**
 * Carrefour à régulation de feux (CDC §5.1). Les valeurs de `techSystem`,
 * `operator` et `status.state` sont du **vocabulaire propre au réseau**
 * (`config.junctionVocabulary`) — le contrat ne fige pas d'enum.
 */
export const JunctionStatus = z.object({
    /** null = aucun marqueur posé. Sinon une valeur de config.junctionVocabulary.statuses. */
    state: z.string().nullable(),
    note: z.string().nullable(),
    byPost: z.string().nullable(), // LE POSTE, jamais la personne (CDC §7.3)
    since: IsoDateTime.nullable(),
    /** durée depuis `since` si `state != null` ; sert à l'alerte « non résolu ». */
    unresolvedForSeconds: z.number().int().nonnegative().nullable(),
});
export const Junction = z.object({
    id: OpaqueId,
    code: z.string(),
    name: z.string(),
    position: Position.pick({ lat: true, lon: true }),
    techSystem: z.string().nullable(),
    operator: z.string().nullable(),
    remoteControllable: z.boolean(),
    impactedLineIds: z.array(OpaqueId),
    status: JunctionStatus,
});
export const JunctionsResponse = z.object({ seq: Seq, junctions: z.array(Junction) }); // seq : D-009
/**
 * `PATCH /networks/{n}/junctions/{id}/status` — **quatrième écriture de l'API**
 * (décision utilisateur 2026-09-04). Marqueur d'observation partagé entre postes.
 * N'agit ni sur le réseau ni sur les feux. Auteur = le poste, jamais la
 * personne (CDC §7.3). `post` est **requis dans le corps**, comme pour
 * `DeviationAckRequest` : tant que l'authentification par poste (B7.2) n'est
 * pas branchée, il n'y a pas de session dont le déduire.
 */
export const JunctionStatusPatch = z.object({
    state: z.string().nullable(), // null = lever le marqueur
    note: z.string().max(280).optional(),
    post: z.string(),
});
/** `GET /networks/{n}/junctions/alerts` — carrefours signalés depuis trop longtemps. */
export const JunctionAlert = z.object({
    junctionId: OpaqueId,
    code: z.string(),
    name: z.string(),
    state: z.string(),
    since: IsoDateTime,
    unresolvedForSeconds: z.number().int().nonnegative(),
});
export const JunctionAlertsResponse = z.object({
    alerts: z.array(JunctionAlert),
});
//# sourceMappingURL=junction.js.map